"use strict";
exports.__esModule = true;
exports.DesignerApplicationConfigurationBuilder = exports.DesignerApplicationConfiguration = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var Viewer3DEnvironment_1 = require("./Viewer3DEnvironment");
var Design_1 = require("./Design");
var DesignerApplicationConfiguration = /** @class */ (function () {
    function DesignerApplicationConfiguration() {
    }
    DesignerApplicationConfiguration.getEditableSides = function (sideConfig) {
        return sideConfig.filter(function (sideConfig) { return sideConfig.editable === true; }).map(function (sideConfig) { return sideConfig.side; });
    };
    return DesignerApplicationConfiguration;
}());
exports.DesignerApplicationConfiguration = DesignerApplicationConfiguration;
var DesignerApplicationConfigurationBuilder = /** @class */ (function () {
    function DesignerApplicationConfigurationBuilder(designerApplicationConfiguration) {
        this.designerApplicationConfiguration = designerApplicationConfiguration;
    }
    DesignerApplicationConfigurationBuilder.initialiseWithDefaults = function () {
        return new DesignerApplicationConfigurationBuilder({
            defaultLanguage: core_common_domain_1.Language.ENGLISH,
            availableLanguages: [core_common_domain_1.Language.ENGLISH],
            theme: null,
            viewer3DEnvironment: Viewer3DEnvironment_1.Viewer3DEnvironmentBuilder.initialiseWithDefaultsWithoutHDRI().build(),
            sideConfig: [
                {
                    side: Design_1.Side.FRONT,
                    editable: true
                },
                {
                    side: Design_1.Side.BACK,
                    editable: false
                }
            ]
        });
    };
    DesignerApplicationConfigurationBuilder.prototype.build = function () {
        return this.designerApplicationConfiguration;
    };
    return DesignerApplicationConfigurationBuilder;
}());
exports.DesignerApplicationConfigurationBuilder = DesignerApplicationConfigurationBuilder;
